let bonnetReferenceConfiguration = {
  customBasePath: null
};
export function getBonnetReferenceConfiguration() {
  return bonnetReferenceConfiguration;
}
export function setBonnetReferenceConfiguration() {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  bonnetReferenceConfiguration = {
    ...bonnetReferenceConfiguration,
    ...config
  };
}